<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="30%"
      title="场地区域"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="courseForm">
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="form.name" placeholder="如5000送300"></el-input>
        </el-form-item>
         <el-form-item label="赠送金额" prop="reward_amount">
          <el-input v-model="form.reward_amount" placeholder="请输入金额"></el-input>
        </el-form-item>
         <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
      v-model="form.start_time"
      type="date"
      value-format="yyyy-MM-dd 00:00:00"
      placeholder="选择日期">
    </el-date-picker>
        </el-form-item>
         <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
      v-model="form.end_time"
      type="date"
       value-format="yyyy-MM-dd 23:59:59"
      placeholder="选择日期">
    </el-date-picker>
        </el-form-item>
         <el-form-item label="最小触发值" prop="min_amount">
          <el-input v-model="form.min_amount" placeholder="规则生效范围，如5000"></el-input>
        </el-form-item>
         <el-form-item label="最大触发值" prop="max_amount">
          <el-input v-model="form.max_amount" placeholder="如10000"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      if_clear: true,
      count: 1,
      cityList: [],
    };
  },

  mounted() {},

  methods: {
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/uRechRule/insert";

      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/user/uRechRule/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>